import { Component } from '@angular/core';
import { TaskViewBase } from '@tasks/task-view-base';
import { GanttChartViewComponent } from '@tasks/task-view-gantt/gantt-chart-view/gantt-chart-view.component';

@Component({
  selector: 'app-task-view-gantt',
  standalone: true,
  imports: [GanttChartViewComponent],
  template: `<gantt-chart-view (taskColumnClickEvent)="openTaskDetail($event)"></gantt-chart-view>`,
  styleUrl: './task-view-gantt.component.scss',
})
export class TaskViewGanttComponent extends TaskViewBase {}
